angular.module('app.notifications', [
    'route',
    'scrf.notifications',
]);
